import { AppointmentRequestDetails } from 'apps/wrapper/src/services/appointment/types/appointment-request-details';
import CarrierSummary from 'apps/wrapper/src/services/insurance/types/carrier-name';
import { IvSummaryStatus } from 'apps/wrapper/src/services/insurance/types/iv-summary-status';
import { Provider } from 'apps/wrapper/src/services/insurance/types/provider';
import { createContext } from 'react';
import { VerificationSummary } from '../../../../../services/insurance/types/verification-summary';

export interface ApptRequestIvStatusDialogContextProps {
  opened: boolean;
  onClose: () => void;
  isReady: boolean;
  isLoading: boolean;
  setIsLoading: (value: boolean) => void;
  locationId: number;
  appointmentRequest: AppointmentRequestDetails | undefined;
  ivSummary: VerificationSummary | undefined;
  providers: Provider[];
  getProvider: (providerId?: number) => Provider | undefined | null;
  getCarrierSummary: (carrierNameId?: number) => CarrierSummary | undefined | null;
  sendIvStatusUpdatedEvent: (status: IvSummaryStatus) => void;
}

export const ApptRequestIvStatusDialogContext = createContext<ApptRequestIvStatusDialogContextProps>(null!);
